/* eslint-disable no-mixed-operators */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, {
  memo, useState, useCallback, useRef, useEffect,
} from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { CONST_RETAIL_APPLICANT } from 'shared/constants';
import CheckIcons from 'assets/icons/check-icon.svg';
import './StatusBox.scss';

const {
  SELECT_BOX: { APPROVE, REWORK },
  STATUS: {
    APPROVED, COMPLETE, PARTIAL, UNDER_REVIEW,
  },
  DROPDOWN: {
    COMPLETED,
  },
} = CONST_RETAIL_APPLICANT;

interface Props {
  title?: string,
  status?: string,
  statusDetail?: any,
  isDropdown?: boolean,
  dropDownList?: [string, string],
  className?: string,
  onStatusChange?: ((event: React.ChangeEvent<HTMLInputElement>) => void) | undefined,
  isQualified?:boolean,
  isSuccess?:boolean,
  isDropDownValue?:boolean,
  isShowDate?:boolean,
  isAprroved?:boolean
  isDisabled?: boolean,
}

/**
 * @param default: <StatusBox title="Application Forms" status="Rework"
 * statusDetail={(<FormattedMessage id="translationID" values={{b: (...chunks) => <b>{chunks}</b>,}}/>)}/>
 *
 * @param isDropdown: <StatusBox isDropdown />
 *
 * @param approved: <StatusBox isDropdown
 * statusDetail={(<FormattedMessage id="123" values={{ b: (...chunks) => <b>{chunks}</b>, span: (...chunks) => <span>{chunks}</span>,}}/>)} />
 */

const StatusBox:React.FC<Props> = memo(({
  title = null, status = null, statusDetail = null, isDropdown = false, isSuccess = false,
  dropDownList = [APPROVE, REWORK], className = null, onStatusChange = () => {}, isQualified = false, isAprroved = false,
  isDropDownValue = false, isShowDate = false,
  isDisabled,
}) => {
  const [state, setState] = useState({
    statusValue: status,
    data: dropDownList,
  });
  const { statusValue, data } = state;
  useEffect(() => {
    setState({ ...state, statusValue: status });
    // eslint-disable-next-line
  }, [status]);
  //* * Show dropdown list */
  const [isShowData, setShowData] = useState(false);

  const dropDownRef = useRef <HTMLUListElement>(null);

  //* * Handle click item dropdown */
  const handleSelect = useCallback((val) => {
    const dataHasValue = [APPROVED, REWORK];
    const valueChange = val === APPROVE ? APPROVED : val;
    setState({
      statusValue: valueChange,
      data: dataHasValue,
    });
    onStatusChange(valueChange);
    setShowData(!isShowData);
    // eslint-disable-next-line
  }, [isShowData]);

  const handleShowDropDown = () => {
    if (statusValue !== APPROVED && isDropdown && !isSuccess || isQualified) {
      setShowData(!isShowData);
    }
  };

  //* * Handle Click OutSide */
  const handleClickOutside = (event) => {
    if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
      setShowData(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  });

  const classes = classNames({
    statusBox: true,
    'statusBox--dropdown': isDropdown && !isAprroved,
    'statusBox--approved': isDropdown && statusDetail !== null && !isDropDownValue && !isAprroved, // Condition: (isDropdown &&  statusDetail), statusDetail format: "Approved on <b>14 Oct 2020</b> <span>by <b>Jon Snow</b></span>"
    'statusBox--removeDotBorder': (isDropdown && statusValue !== null || isDropDownValue) && !isAprroved, // isDropdown && statusValue :: When user approved
    'statusBox--partial': statusValue === PARTIAL || statusValue === UNDER_REVIEW,
    'statusBox--complete': (statusValue === COMPLETE || statusValue === APPROVED || statusValue === COMPLETED) && !isAprroved,
    'statusBox--rework': (statusValue === REWORK) && !isAprroved,
    'statusBox--qualified': isQualified && !isAprroved,
    'statusBox--approved--qualified': isAprroved,
    'statusBox--underReview': statusValue === UNDER_REVIEW,
    'statusBox--removeArrow': statusValue === APPROVED,
    'statusBox--disabled': isDisabled,
  });
  // console.log('isDropdown', !isDropdown && statusDetail !== null);
  return (
    <div className={`${className || ''} ${classes}`}>
      <div className="statusBox__body">

        {!isDropdown && (
        <>
          <p className="statusBox__body__title">{title}</p>
          <span className="statusBox__body__status">{statusValue === COMPLETED ? COMPLETE : statusValue}</span>
        </>
        )}
        {/* render component has isDropdown */}
        {isDropdown && (
          <>
            {statusValue !== null || isDropDownValue ? (
              <button type="button" className="statusBox__body__dropDownValue" onClick={handleShowDropDown}>
                <p className="statusBox__body__title">
                  <FormattedMessage id="manageApplication.markazAdminStatus" />
                </p>
                <span className="statusBox__body__status">{statusValue}</span>
              </button>
            ) : (
              <button type="button" className="statusBox__body__noDropDownValue" onClick={handleShowDropDown}>
                {statusDetail === null ? (
                  <FormattedMessage
                    id="manageApplication.updateMarkazStatus"
                    values={{
                      small: (...chunks) => <small>{chunks}</small>,
                    }}
                  />
                ) : statusDetail}
              </button>
            )}
            {isShowData && !isDisabled && (
            <ul className="statusBox__body__list" ref={dropDownRef}>
              {data.map((item, idx) => (
                <li
                  className={item}
                  key={`statusBox-${idx}`}
                  onClick={() => handleSelect(item)}
                >
                  {item}
                  <img src={CheckIcons} alt="icon" />
                </li>
              ))}
            </ul>
            )}
          </>
        )}

      </div>
      { (isQualified || isShowDate) && statusDetail && statusDetail.props && statusDetail.props.id && (
      <div className="statusBox__date">
        {statusDetail}
      </div>
      )}
    </div>
  );
});

export default StatusBox;
